import { Box, MenuItem, Select } from '@mui/material';

import { LIST } from './tokens';

export type FilterOption = { value: string; label: string };

export function FilterSelect({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: string;
  options: FilterOption[];
  onChange: (value: string) => void;
}) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        height: 36,
        pl: '12px',
        border: `1px solid ${LIST.divider}`,
        borderRadius: '9999px',
        bgcolor: LIST.cardBg,
        fontFamily: LIST.font,
        fontSize: 16,
        lineHeight: '24px',
        color: LIST.muted,
        whiteSpace: 'nowrap',
      }}
    >
      {label}:
      <Select
        size="small"
        variant="standard"
        disableUnderline
        value={value}
        onChange={(event) => onChange(String(event.target.value))}
        inputProps={{ 'aria-label': label }}
        sx={{
          fontFamily: LIST.font,
          fontSize: 16,
          fontWeight: 600,
          lineHeight: '24px',
          color: LIST.ink,
          '& .MuiSelect-select': { py: '6px', pl: '4px', pr: '32px !important' },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value} sx={{ fontFamily: LIST.font, fontSize: 16 }}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
